import React, { Component } from "react";
import { MAX_WIDTH_SP } from "../../const";
import DesignTool from "../../designtool";

export default class ListMenu extends Component {
  handleShowModalMaterial(id) {
    let {
      handleUpdateState,
      idMaterialActive,
      getWidthBrowser,
      isShowPopupSp
    } = this.props;

    if (getWidthBrowser() < MAX_WIDTH_SP) {
      // DesignTool.updateSizeRing();
      if (idMaterialActive === id && isShowPopupSp) {
        handleUpdateState("isShowPopupSp", false);
      } else {
        handleUpdateState("isShowPopupSp", true);
      }

      handleUpdateState("idMaterialActive", id);

      switch (id) {
        case 1:
          handleUpdateState("isShowModalRingList", true);
          handleUpdateState("isShowModalCategoryList", false);
          handleUpdateState("isShowModalFortuneList", false);
          handleUpdateState("isShowModalColorList", false);
          break;
        case 2:
          handleUpdateState("isShowModalRingList", false);
          handleUpdateState("isShowModalCategoryList", true);
          handleUpdateState("isShowModalFortuneList", false);
          handleUpdateState("isShowModalColorList", false);
          break;
        case 3:
          handleUpdateState("isShowModalRingList", false);
          handleUpdateState("isShowModalCategoryList", false);
          handleUpdateState("isShowModalFortuneList", true);
          handleUpdateState("isShowModalColorList", false);
          break;
        case 4:
          handleUpdateState("isShowModalRingList", false);
          handleUpdateState("isShowModalCategoryList", false);
          handleUpdateState("isShowModalFortuneList", false);
          handleUpdateState("isShowModalColorList", true);
          break;
        default:
          break;
      }
      return;
    }

    handleUpdateState("idMaterialActive", id);
    handleUpdateState("isShowModalMaterial", true);
  }

  render() {
    let { ringIdActive, isShowPopupSp, idMaterialActive } = this.props;
    let ringName = "リング";

    // Check ring type
    switch (ringIdActive) {
      case 2:
        ringName = "紐";
        break;
      case 7:
        ringName = "金具";
        break;
      default:
        ringName = "リング";
        break;
    }
    let materialList = [
      {
        id: 1,
        url: "/img/ring_new.png",
        name: ringName,
        className: "popup_ring_new"
      },
      {
        id: 2,
        url: "/img/storn_new.png",
        name: "素材",
        className: "popup_storn_new"
      },
      {
        id: 3,
        url: "/img/weather_star_new.png",
        name: "運気",
        className: "popup_weather_star_new"
      },
      {
        id: 4,
        url: "/img/hart_new.png",
        name: "カラー",
        className: "popup_hart_new"
      }
    ];
    return (
      <ul>
        {materialList.map((item, index) => (
          <li
            key={index}
            className={`${
              isShowPopupSp && idMaterialActive === item.id ? "tab_active" : ""
            }`}
          >
            <button onClick={() => this.handleShowModalMaterial(item.id)}>
              <div className="btn_icon">
                <img className={item.className} src={item.url} alt="" />
              </div>
              <span>{item.name}</span>
            </button>
          </li>
        ))}
      </ul>
    );
  }
}
